// ORIA – page produit. Généré depuis product.html par tools/convert-product.mjs.
// SAFE STORAGE HELPERS (private mode / blocked storage must never break the page)
    function safeGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function safeSet(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) {}
    }

    // COMPLETE TWO-WAY DICTIONARY (HU <-> FR)
    // SMART STICKY CHECKOUT BAR VISIBILITY CONTROLLER
    function updateStickyBarVisibility() {
      const stickyBar = document.getElementById('sticky-checkout-bar');
      const heroSection = document.getElementById('hero-split-screen');
      const footer = document.querySelector('footer');
      
      if (!stickyBar || !heroSection) return;

      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const viewportHeight = window.innerHeight;

      // Condition 1: Must be past hero section (heroBottom <= 150)
      // Condition 2: Must NOT be at footer bottom (footerTop > viewportHeight + 20)
      const isPastHero = heroBottom <= 150;
      const isAtFooter = footerTop <= viewportHeight + 20;

      if (isPastHero && !isAtFooter) {
        stickyBar.classList.remove('translate-y-full');
        stickyBar.classList.add('translate-y-0');
      } else {
        stickyBar.classList.remove('translate-y-0');
        stickyBar.classList.add('translate-y-full');
      }
    }

    // Boutique en hongrois uniquement : plus de changement de langue côté JS
    let activeLang = 'hu';

    document.addEventListener('DOMContentLoaded', () => {
      // 0. LAZY-LOAD SECTION 5 VIDEOS ON INTERSECTION (ZERO INITIAL NETWORK IMPACT)
      const lazyVideos = document.querySelectorAll('video.lazy-video');
      if ('IntersectionObserver' in window && lazyVideos.length > 0) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              if (video.dataset.src && !video.getAttribute('src')) {
                video.src = video.dataset.src;
                video.load();
              }
              video.play().catch(() => {});
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { rootMargin: '300px 0px' });
        lazyVideos.forEach(v => videoObserver.observe(v));
      } else {
        lazyVideos.forEach(v => {
          if (v.dataset.src) {
            v.src = v.dataset.src;
            v.play().catch(() => {});
          }
        });
      }



      // 1. DYNAMIC STICKY FOOTER CONTROLLER
      window.addEventListener('scroll', () => {
        updateStickyBarVisibility();
      });

      // Initial check for sticky bar visibility
      updateStickyBarVisibility();


      // 3. DYNAMIC COUNTDOWN TIMER (3 Hours persistent localStorage in HH:MM:SS)
      const COUNTDOWN_KEY = 'oria_promo_countdown_v2';
      const DURATION_SECONDS = 3 * 3600; // 3 hours

      function getCountdownEndTime() {
        const now = Math.floor(Date.now() / 1000);
        let stored = parseInt(safeGet(COUNTDOWN_KEY) || '0', 10);
        // If not stored, expired, or far in the future (> 3h), reset
        if (!stored || stored <= now || stored > now + DURATION_SECONDS) {
          stored = now + DURATION_SECONDS;
          try { safeSet(COUNTDOWN_KEY, stored.toString()); } catch(e){}
        }
        return stored;
      }

      let promoEndTime = getCountdownEndTime();

      function updateTimerDisplay() {
        const now = Math.floor(Date.now() / 1000);
        let remaining = promoEndTime - now;

        if (remaining <= 0) {
          promoEndTime = now + DURATION_SECONDS;
          try { safeSet(COUNTDOWN_KEY, promoEndTime.toString()); } catch(e){}
          remaining = DURATION_SECONDS;
        }

        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        const formatted = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        const timerEls = document.querySelectorAll('.countdown-timer-promo, #countdown-timer-promo, #countdown-timer-promo-dup');
        timerEls.forEach(el => {
          el.textContent = formatted;
        });
      }

      function initCountdown() {
        promoEndTime = getCountdownEndTime();
        updateTimerDisplay();
        setInterval(updateTimerDisplay, 1000);
      }

      initCountdown();


      // 4. MOBILE MENU DRAWER TOGGLE & AUTO-CLOSE
      const menuBtn = document.getElementById('mobile-menu-toggle');
      const menuDrawer = document.getElementById('mobile-menu-drawer');
      if (menuBtn && menuDrawer) {
        menuBtn.addEventListener('click', () => {
          const isHidden = menuDrawer.classList.contains('hidden');
          menuDrawer.classList.toggle('hidden');
          menuBtn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        });

        // Close drawer when clicking any navigation link inside it
        menuDrawer.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', () => {
            menuDrawer.classList.add('hidden');
            menuBtn.setAttribute('aria-expanded', 'false');
          });
        });
      }

      // 5. REVIEWS CAROUSEL INITIALIZER
      initReviewCarousel();

      // 6. LIEN PROFOND (?variant=ID standard Shopify, ou ?pack=1|2|3) + RADIOS ACCESSIBLES AU CLAVIER
      try {
        const params = new URLSearchParams(window.location.search);
        let packParam = parseInt(params.get('pack'), 10);
        const variantParam = params.get('variant');
        if (variantParam) {
          const card = document.querySelector('.bundle-card[data-variant-id="' + variantParam + '"]');
          if (card) packParam = parseInt(card.dataset.pack, 10);
        }
        if (oriaPackCard(packParam)) {
          selectBundle(packParam);
          const panel = document.getElementById('bundle-selector-panel');
          if (panel) setTimeout(() => panel.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
        }
      } catch (e) {}

      document.querySelectorAll('input[name="bundle_selection"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const packNum = parseInt(radio.id.replace('radio-bundle-', ''), 10);
          if (radio.checked && oriaPackCard(packNum)) selectBundle(packNum);
        });
      });

    });

    // 5. IMAGE GALLERY THUMBNAIL SWITCHER
    function switchMainImage(src, btnEl) {
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg) {
        mainImg.style.opacity = '0.3';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 150);
      }
      document.querySelectorAll('.thumb-btn').forEach(btn => {
        btn.classList.remove('border-brand-obsidian');
        btn.classList.add('border-transparent');
      });
      btnEl.classList.remove('border-transparent');
      btnEl.classList.add('border-brand-obsidian');
    }

    // 6. DYNAMIC BUNDLE SELECTOR LOGIC (PACKS 1, 2, 3)
    let currentBundleOption = 2;

    function selectBundle(optionNum) {
      if (!oriaPackCard(optionNum)) return;
      currentBundleOption = optionNum;

      // === BUNDLE ELEMENTS ===
      const opt1 = document.getElementById('bundle-option-1');
      const opt2 = document.getElementById('bundle-option-2');
      const opt3 = document.getElementById('bundle-option-3');
      const radio1 = document.getElementById('radio-bundle-1');
      const radio2 = document.getElementById('radio-bundle-2');
      const radio3 = document.getElementById('radio-bundle-3');
      const giftBox2 = document.getElementById('gift-container-bundle-2');
      const giftBox3 = document.getElementById('gift-container-bundle-3');

      const ctaPrice = document.getElementById('cta-price-display');
      const stickyPrice = document.getElementById('sticky-price-display');
      const stickySub = document.querySelector('[data-i18n="sticky_sub"]');

      // --- CARD STYLING (RESPONSIVE FOR ALL SCREENS) ---
      if (opt1) {
        opt1.className = 'bundle-card cursor-pointer relative rounded-xl sm:rounded-2xl p-3 sm:p-4 transition-all hover-lift ' +
          (optionNum === 1 
            ? 'bg-neutral-50/50 border-2 border-brand-obsidian shadow-sm' 
            : 'bg-white border border-brand-border');
      }
      if (opt2) {
        opt2.className = 'bundle-card cursor-pointer relative rounded-xl sm:rounded-2xl p-3 sm:p-4 transition-all hover-lift ' +
          (optionNum === 2 
            ? 'bg-gradient-to-br from-[#FFF5F7] via-[#FFF0F3] to-[#FFFAFA] border-2 border-[#F43F5E] shadow-2xs' 
            : 'bg-white border border-brand-border');
      }
      if (opt3) {
        opt3.className = 'bundle-card cursor-pointer relative rounded-xl sm:rounded-2xl p-3 sm:p-4 transition-all hover-lift ' +
          (optionNum === 3 
            ? 'bg-gradient-to-br from-[#F5F3FF] via-[#EDE9FE] to-[#FAF5FF] border-2 border-[#5B21B6] shadow-sm' 
            : 'bg-white border border-brand-border');
      }

      // Radios synchronization
      if (radio1) radio1.checked = (optionNum === 1);
      if (radio2) radio2.checked = (optionNum === 2);
      if (radio3) radio3.checked = (optionNum === 3);

      // --- GIFT CONTAINERS (SHOW/HIDE 100% BULLETPROOF) ---
      if (giftBox2) {
        if (optionNum === 2) {
          giftBox2.classList.remove('hidden');
          giftBox2.style.display = 'block';
        } else {
          giftBox2.classList.add('hidden');
          giftBox2.style.display = 'none';
        }
      }
      if (giftBox3) {
        if (optionNum === 3) {
          giftBox3.classList.remove('hidden');
          giftBox3.style.display = 'block';
        } else {
          giftBox3.classList.add('hidden');
          giftBox3.style.display = 'none';
        }
      }

      // Prix, texte sticky et variante Shopify du formulaire
      syncPack(optionNum);
    }

    // SHOPIFY : le pack choisi devient la variante du formulaire produit (lue par EasySell)
    function oriaPackCard(n) {
      return document.getElementById('bundle-option-' + n);
    }

    function syncPack(optionNum) {
      const card = oriaPackCard(optionNum);
      if (!card) return;
      const priceText = card.dataset.price;
      const ctaPrice = document.getElementById('cta-price-display');
      const stickyPrice = document.getElementById('sticky-price-display');
      const stickySub = document.querySelector('[data-i18n="sticky_sub"]');
      if (priceText) {
        if (ctaPrice) ctaPrice.textContent = priceText;
        if (stickyPrice) stickyPrice.textContent = priceText;
      }
      if (stickySub && card.dataset.stickySub) stickySub.textContent = card.dataset.stickySub;

      const variantId = card.dataset.variantId;
      if (!variantId) return;
      const idInput = document.querySelector('#oria-product-form input[name="id"]');
      if (idInput && idInput.getAttribute('value') !== variantId) {
        idInput.value = variantId;
        idInput.setAttribute('value', variantId); // EasySell lit l'attribut, pas la propriété
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.delete('pack');
      window.history.replaceState(window.history.state, '', url.toString());
    }

    // Bouton d'achat : ouvre la popup EasySell (le bouton ajouté par l'app est masqué en CSS).
    // Sans l'app, le formulaire part normalement vers le panier puis le checkout « Utánvét ».
    // EasySell ajoute le pack au panier à chaque ouverture : on retire d'abord les packs ORIA
    // déjà présents, sinon une cliente qui change de pack commanderait les deux.
    document.addEventListener('click', (event) => {
      if (!event.target.closest('#main-add-to-cart-cta')) return;
      const esButton = document.querySelector('#oria-product-form .es-popup-button');
      if (!esButton) return;
      event.preventDefault();
      const updates = {};
      document.querySelectorAll('.bundle-card[data-variant-id]').forEach(card => {
        if (card.dataset.variantId) updates[card.dataset.variantId] = 0;
      });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      }).catch(() => {}).finally(() => esButton.click());
    });

    // Bouton de la barre sticky : ouvre directement le formulaire de commande
    function oriaOpenOrder(event) {
      const btn = document.getElementById('main-add-to-cart-cta');
      if (!btn || btn.disabled) return true; // repli : défilement vers les packs
      event.preventDefault();
      btn.click();
      return false;
    }

    function toggleVersusAccordion() {
      if (window.innerWidth >= 640) return;

      const content = document.getElementById('versus-accordion-body');
      const chevron = document.getElementById('versus-chevron-svg');
      const btn = document.getElementById('versus-header-btn');
      if (!content) return;

      const isOpen = content.classList.contains('open');
      if (isOpen) {
        content.style.maxHeight = null;
        content.classList.remove('open');
        if (chevron) chevron.classList.remove('rotate-180');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      } else {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 20 + "px";
        if (chevron) chevron.classList.add('rotate-180');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
    }

    function toggleAccordion(accId, headerEl) {
      const content = document.getElementById(accId);
      const icon = headerEl.querySelector('.accordion-icon');
      const isOpen = content.classList.contains('open');

      document.querySelectorAll('.accordion-content').forEach(el => {
        el.style.maxHeight = null;
        el.classList.remove('open');
      });
      document.querySelectorAll('.accordion-icon').forEach(ic => {
        ic.textContent = '+';
      });

      if (!isOpen) {
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 30 + "px";
        if (icon) icon.textContent = '−';
      }
    }

    // 8. REVIEWS CAROUSEL SCROLL & INTERACTIVE CONTROLLERS
    function scrollReviewCarousel(direction) {
      const track = document.getElementById('reviews-carousel-track');
      if (track) {
        const firstCard = track.querySelector('.snap-start');
        const cardWidth = firstCard ? firstCard.offsetWidth + 24 : 380;
        track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      }
    }

    function jumpToReview(index) {
      const track = document.getElementById('reviews-carousel-track');
      if (track) {
        const cards = track.querySelectorAll('.snap-start');
        if (cards[index]) {
          if (typeof cards[index].scrollIntoView === 'function') {
            cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          } else {
            track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        }
      }
    }

    function initReviewCarousel() {
      const track = document.getElementById('reviews-carousel-track');
      const progressBar = document.getElementById('reviews-progress-bar');
      const progressContainer = document.getElementById('reviews-progress-container');
      const dots = document.querySelectorAll('.review-dot');

      if (!track) return;

      function updateProgress() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          if (progressBar) {
            progressBar.style.width = '100%';
            progressBar.style.marginLeft = '0%';
          }
          return;
        }

        const scrollRatio = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
        
        // Update bar width and position
        if (progressBar) {
          const visibleRatio = track.clientWidth / track.scrollWidth;
          const barWidthPercent = Math.max(15, Math.min(40, visibleRatio * 100));
          const movePercent = scrollRatio * (100 - barWidthPercent);
          progressBar.style.width = barWidthPercent + '%';
          progressBar.style.marginLeft = movePercent + '%';
        }

        // Update active dot
        if (dots && dots.length > 0) {
          const cards = track.querySelectorAll('.snap-start');
          const totalCards = cards.length || 10;
          const activeIndex = Math.min(totalCards - 1, Math.round(scrollRatio * (totalCards - 1)));
          dots.forEach((dot, idx) => {
            if (idx === activeIndex) {
              dot.className = "review-dot w-6 h-2 rounded-full bg-brand-obsidian transition-all duration-300 cursor-pointer";
            } else {
              dot.className = "review-dot w-2 h-2 rounded-full bg-neutral-300 hover:bg-neutral-400 transition-all duration-300 cursor-pointer";
            }
          });
        }
      }

      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);

      // Click on progress bar container to jump
      if (progressContainer) {
        progressContainer.addEventListener('click', (e) => {
          const rect = progressContainer.getBoundingClientRect();
          const clickRatio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
          const maxScroll = track.scrollWidth - track.clientWidth;
          track.scrollTo({ left: clickRatio * maxScroll, behavior: 'smooth' });
        });
      }

      // Mouse drag to scroll support on desktop
      let isDown = false;
      let startX = 0;
      let scrollStart = 0;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        track.classList.add('cursor-grabbing');
        track.classList.remove('cursor-grab');
        startX = e.pageX - track.offsetLeft;
        scrollStart = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (isDown) {
          isDown = false;
          track.classList.remove('cursor-grabbing');
          track.classList.add('cursor-grab');
        }
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5;
        track.scrollLeft = scrollStart - walk;
      });

      // Initial progress update
      updateProgress();
    }

    // 9. SECTION 5 VIDEO CAROUSEL SCROLL CONTROLLER
    function scrollVideoCarousel(direction) {
      const track = document.getElementById('video-carousel-track');
      if (track) {
        const cardWidth = 300;
        track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      }
    }

    // 10. SECTION 5 VALUE STACK 2-TAB SWITCHER
    function switchEduTab(tabName) {
      const btnDetox = document.getElementById('tab-btn-detox');
      const btnMath = document.getElementById('tab-btn-math');
      const panelDetox = document.getElementById('tab-panel-detox');
      const panelMath = document.getElementById('tab-panel-math');

      if (tabName === 'detox') {
        if (btnDetox) {
          btnDetox.className = "flex-1 py-2.5 px-3 min-h-[44px] rounded-xl font-bold text-xs bg-brand-obsidian text-white shadow-xs transition-all cursor-pointer hover:bg-neutral-700 hover:shadow-md flex items-center justify-center space-x-1 sm:space-x-1.5";
        }
        if (btnMath) {
          btnMath.className = "flex-1 py-2.5 px-3 min-h-[44px] rounded-xl font-medium text-xs text-neutral-600 hover:text-brand-obsidian hover:bg-white hover:shadow-sm transition-all cursor-pointer flex items-center justify-center space-x-1 sm:space-x-1.5";
        }
        if (panelDetox) panelDetox.classList.remove('hidden');
        if (panelMath) panelMath.classList.add('hidden');
      } else if (tabName === 'math') {
        if (btnMath) {
          btnMath.className = "flex-1 py-2.5 px-3 min-h-[44px] rounded-xl font-bold text-xs bg-brand-obsidian text-white shadow-xs transition-all cursor-pointer hover:bg-neutral-700 hover:shadow-md flex items-center justify-center space-x-1 sm:space-x-1.5";
        }
        if (btnDetox) {
          btnDetox.className = "flex-1 py-2.5 px-3 min-h-[44px] rounded-xl font-medium text-xs text-neutral-600 hover:text-brand-obsidian hover:bg-white hover:shadow-sm transition-all cursor-pointer flex items-center justify-center space-x-1 sm:space-x-1.5";
        }
        if (panelMath) panelMath.classList.remove('hidden');
        if (panelDetox) panelDetox.classList.add('hidden');
      }
    }

    // 11. SECTION BOTTOM REVIEWS TOGGLE CONTROLLER
    function toggleMoreReviews() {
      const wrapper = document.getElementById('reviews-grid-wrapper');
      const fade = document.getElementById('reviews-fade-overlay');
      const textEl = document.getElementById('load-more-text');
      const iconEl = document.getElementById('load-more-icon');
      if (!wrapper) return;
      
      const isExpanded = wrapper.classList.contains('max-h-none');
      const currentLang = activeLang;

      if (!isExpanded) {
        wrapper.classList.remove('max-h-[920px]', 'lg:max-h-[980px]');
        wrapper.classList.add('max-h-none');
        if (fade) fade.classList.add('hidden');
        if (textEl) {
          textEl.textContent = currentLang === 'hu' ? 'Kevesebb vélemény' : 'Afficher moins d\'avis';
        }
        if (iconEl) iconEl.textContent = 'expand_less';
      } else {
        wrapper.classList.add('max-h-[920px]', 'lg:max-h-[980px]');
        wrapper.classList.remove('max-h-none');
        if (fade) fade.classList.remove('hidden');
        if (textEl) {
          textEl.textContent = currentLang === 'hu' ? 'További vélemények betöltése' : 'Afficher plus d\'avis';
        }
        if (iconEl) iconEl.textContent = 'expand_more';

        const bottomSec = document.getElementById('bottom-reviews-section');
        if (bottomSec) bottomSec.scrollIntoView({ behavior: 'smooth' });
      }
    }

// Fenêtre vidéo agrandie
(function () {
      var box = document.getElementById('video-lightbox');
      var player = document.getElementById('video-lightbox-player');
      var closeBtn = document.getElementById('video-lightbox-close');
      if (!box || !player) return;
      var lastCard = null;
      function openFrom(card) {
        var v = card.querySelector('video');
        if (!v) return;
        var src = v.getAttribute('src') || v.dataset.src;
        if (!src) return;
        lastCard = card;
        player.poster = v.getAttribute('poster') || '';
        player.src = src;
        player.muted = true;
        box.classList.remove('hidden'); box.classList.add('flex');
        document.documentElement.style.overflow = 'hidden';
        var pr = player.play(); if (pr && pr.catch) pr.catch(function () {});
        closeBtn.focus();
      }
      function close() {
        if (box.classList.contains('hidden')) return;
        player.pause();
        player.removeAttribute('src'); player.load();
        box.classList.add('hidden'); box.classList.remove('flex');
        document.documentElement.style.overflow = '';
        if (lastCard) lastCard.focus();
      }
      document.querySelectorAll('.video-card').forEach(function (card) {
        card.addEventListener('click', function () { openFrom(card); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openFrom(card); } });
      });
      closeBtn.addEventListener('click', close);
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    })();

// Galerie : glisser le pouce sur la grande photo pour passer à la suivante / précédente
(function () {
  var gallery = document.getElementById('product-gallery-carousel');
  if (!gallery) return;
  var startX = 0, startY = 0, tracking = false;
  function thumbs() { return Array.prototype.slice.call(document.querySelectorAll('.thumb-btn')); }
  function go(step) {
    var list = thumbs();
    if (!list.length) return;
    var current = list.findIndex(function (b) { return b.classList.contains('border-brand-obsidian'); });
    var next = (Math.max(current, 0) + step + list.length) % list.length;
    list[next].click();
    list[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  gallery.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX; startY = e.touches[0].clientY; tracking = true;
  }, { passive: true });
  gallery.addEventListener('touchend', function (e) {
    if (!tracking) return;
    tracking = false;
    var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
